export default "__VITE_ASSET__DRZOznEH__"